import { IUser } from "@sol/sdk";

export enum ActionTypes {
    SET_USER = "SET_USER",
    UNSET_USER = "UNSET_USER",
}

export type IUserState = IUser | null;
